export default __webpack_public_path__ + "static/media/thali.f37bd7a4.png";